/* NOD local design history (Justin 2026-07-24).
 *
 * There is no NOD designs API yet, so nothing an upload engine "saves" ever
 * reaches a backend. Until that API exists, this module keeps a per-browser
 * design history in localStorage and feeds it to the Previous Designs grids:
 *
 *   capture — (a) bysize-v4.js's saveFileToUser stub calls
 *             window.NODLocalDesigns.save() directly;
 *             (b) the legacy engines (bySize.js / __blanksUploadHelper.js)
 *             POST to `${apiURL}/uploads/saveData` — a jQuery ajaxPrefilter
 *             mirrors that payload into storage (the request itself is left
 *             alone: it 404s harmlessly today and keeps working the day a
 *             real /uploads/saveData exists).
 *   serve   — snippets/my-designs-panel.liquid merges NODLocalDesigns.list()
 *             into its designs array (records shaped like server uploads).
 *
 * Records are scoped per customer id when one is on the page, else "guest".
 * When the NOD designs API ships, point capture/serve at it and this module
 * becomes a write-through cache.
 */
(function () {
  'use strict';

  function scope() {
    try {
      if (typeof window.CUSTOMER_ID !== 'undefined' && window.CUSTOMER_ID) return String(window.CUSTOMER_ID);
      if (window.__st && window.__st.cid) return String(window.__st.cid);
    } catch (e) { /* fall through */ }
    return 'guest';
  }
  var KEY = 'nodLocalDesigns:' + scope();
  var MAX = 120;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) { /* quota/private mode */ }
  }
  function baseName(url) {
    return String(url || '').split('?')[0].split('/').pop();
  }
  function save(rec) {
    if (!rec || !rec.file) return;
    var list = read();
    var k = (rec.name || baseName(rec.file)).toLowerCase();
    list = list.filter(function (x) { return (x.name || baseName(x.file)).toLowerCase() !== k; });
    list.unshift({
      key: Date.now().toString(36) + Math.random().toString(36).slice(2, 7),
      file: String(rec.file),
      s3: rec.s3 ? String(rec.s3) : '',
      name: rec.name || baseName(rec.file),
      variantTitle: rec.variantTitle || '',
      gangsheet: !!rec.gangsheet,
      ts: Date.now()
    });
    write(list);
    try { document.body.setAttribute('data-md-has-designs', '1'); } catch (e) { /* pre-body */ }
    try { window.dispatchEvent(new CustomEvent('nod:local-designs-changed')); } catch (e) { /* old browsers */ }
  }
  function list() { return read(); }

  function wirePrefilter() {
    if (!window.jQuery || wirePrefilter.done) return;
    wirePrefilter.done = true;
    window.jQuery.ajaxPrefilter(function (options, originalOptions) {
      if (String(options.url || '').indexOf('/uploads/saveData') === -1) return;
      try {
        var raw = (originalOptions && originalOptions.data) || options.data || '[]';
        var body = typeof raw === 'string' ? JSON.parse(raw) : raw;
        (Array.isArray(body) ? body : [body]).forEach(function (it) {
          if (it && it.file) {
            save({ file: it.file, name: it.file_name, variantTitle: it.variant_title, gangsheet: !!it.gangsheet });
          }
        });
      } catch (e) { /* never break the engine's request */ }
    });
  }
  wirePrefilter();
  document.addEventListener('DOMContentLoaded', wirePrefilter);

  window.NODLocalDesigns = { save: save, list: list };
})();
